import { DEPARTEMENTS } from "./departements";

// Map "35" → "Ille-et-Vilaine"
const DEPT_NAME_BY_CODE = Object.fromEntries(
  DEPARTEMENTS.map((s) => {
    const [code, ...rest] = s.split(" - ");
    return [code, rest.join(" - ")];
  })
);

export const getDeptNameByCode = (code) => {
  if (!code) return "";
  const c = String(code).toUpperCase().padStart(2, "0");
  return DEPT_NAME_BY_CODE[c] || DEPT_NAME_BY_CODE[String(code).toUpperCase()] || "";
};

export default getDeptNameByCode;
